import { useAuthStore } from '@/stores'

let authStore = null
let check = false

export default {
  created() {
    // instantiate only once
    if (!authStore) {
      authStore = useAuthStore()
      const { hasPricebook } = authStore

      // hide the pricing related UI when there is pricebook
      check = hasPricebook
    }
  },
  mounted(el) {
    if (check) {
      el.remove()
    }
  }
}
